import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { baseUrl, timeList, formatDate, formatDateForFile } from "../comman/config";
import Select from "react-select";
import { ChevronUpIcon, ChevronDownIcon } from "@heroicons/react/solid";
import { useNavigate, Link } from "react-router-dom";
import { DateSessionFilter } from "../components/Filter/DateSessionFilter";
import toast, { Toaster } from "react-hot-toast";
import ModalContent from "../components/ModalContent";
import * as XLSX from 'xlsx';
import Loader from "../components/Loader";
import { ItemNameStacked } from '../components/ItemName';

// The freeze pane, the same one Recipe Report uses and for the same reason: the ingredient names
// stay put while the six quantity columns scroll under them, so a number is never read without
// knowing what it is a number of. Capped and allowed to wrap below `sm` so a long name cannot take
// the whole phone screen. The background is set per row rather than here -- a transparent sticky
// cell lets the scrolling columns show through it.
const stickyCol = "sticky left-0 z-20 border border-gray-300 px-2 py-1 max-w-[40vw] sm:max-w-none whitespace-normal sm:whitespace-nowrap";
const qtyHead = "border border-gray-300 px-1 py-1 font-bold";
const qtyCell = "border border-gray-300 px-1 py-1 text-center";

// The dropdowns render into the body so their menus are not clipped by the scroll box the table
// sits in. `editable` is the cream fill this app gives a field somebody is meant to fill in.
//
// Everything else here is width, reclaimed for the value. A vessel name or a time slot in one of
// these boxes on a phone had about forty pixels to show itself in, and react-select's defaults
// were spending a third of the box on chrome: 8px of padding either side of the value, a 1px
// separator with 8px around it, and another 8px each side of the arrow. The arrow stays -- it is
// what says the box is a picker -- on a tighter pad, and the separator goes.
const selectStyles = (editable) => ({
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  placeholder: (provided) => ({ ...provided, fontSize: "0.75rem" }),
  valueContainer: (provided) => ({ ...provided, padding: "0 4px" }),
  singleValue: (provided) => ({ ...provided, fontSize: "0.75rem", margin: 0 }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
  control: (provided) => ({
    ...provided,
    fontSize: "14px",
    minHeight: "32px",
    ...(editable ? { backgroundColor: "#FFFAF0" } : {}),
  }),
});

// import Pagination from "react-js-pagination";

function ProductionSupport() {
  const today = new Date().toISOString().split("T")[0];
  const [mealList, setMealList] = useState([]);
  const [rmDetailForItem, setRMDetailForItem] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [vesselList, setVesselList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [date, setDate] = useState(today);
  const [session, setSession] = useState("");
  const [formData, setFormData] = useState([]);
  const isEffectRan = useRef(false); 
  const [showModal, setShowModal] = useState(false);
  const [batchIndex, setBatchIndex] = useState(null)
  const [loading, setLoading] = useState(false)
  // Which batch card is open. One at a time, and the first one on arrival: a batch is a screenful
  // on a phone, and all of them unrolled at once is the scroll this screen is being rebuilt to
  // get rid of.
  const [openBatch, setOpenBatch] = useState(0);
  // Remarks (stores) is asked once for the item, not once per batch. The column it is kept in is
  // still per-batch in production_support, so the one answer is written to every batch that is
  // saved and read back from whichever batch has one.
  const [storeRemarks, setStoreRemarks] = useState("");

  useEffect(() => {
    getVesselList();
    getIngredientList();
  }, []);
  // No batches until an item says how many it has. How many is production_planning's answer, the
  // same one Kit Requisition builds its screen from -- this screen used a flat five whatever the
  // item had planned, so an item of two batches showed three empty cards and an item of seven
  // showed five with the rest missing.

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null) {
      getRMDetailForItem();
    }
  }, [mealList, activeIndex]);

  useEffect(()=>{
    if(batchIndex >=0){
      setShowModal(true)
    }
  },[batchIndex])

  useEffect(() => {
    if (mealList.length > 0 && activeIndex != null ) {
      const itemId =
        mealList.find((item, index) => index === activeIndex).menu_item_id ??
        null;
      console.log(itemId);
      const fetchDetail = async () => {
        try {
        setLoading(true)
        const condition = `menu_item_id='${itemId}' AND date = '${date}' AND session='${session.value}'`;
        const bd1 = (await axios.post(`${baseUrl}/comman/batch-list`, { queries: [
          { key: 'planned', table: 'production_planning', condition },
          { key: 'support', table: 'production_support',  condition },
        ]})).data.data;
        const plannedDetail = bd1.planned ?? [];
        const supportDetail = bd1.support ?? [];

        // Fetch maharaj data (custom endpoint — cannot use batch-list)
        const maharajResponse = await axios.get(`${baseUrl}/production_support/getMaharajId?date=${date}&session=${session.value}&menu_item_id=${itemId}`);

        const maharaj = maharajResponse.data.data[0].maharaj;
        const bd2 = (await axios.post(`${baseUrl}/comman/batch-list`, { queries: [
          { key: 'recipe',    table: 'receipe_master',             condition: `menu_item_id='${itemId}' AND maharaj=${maharaj}` },
          { key: 'recipe_db', table: 'production_receipe_planning', condition: `${condition} GROUP BY ingredient_id order by id asc` },
        ]})).data.data;
        const RecipeData = { data: { data: bd2.recipe ?? [] } };
        const RecipeDbData = { data: { data: bd2.recipe_db ?? [] } };
        // console.log(RecipeData.data.data);
        let ddArray = [];
        if(RecipeDbData.data.data.length > 0){
          RecipeDbData.data.data.forEach((item, index) => {
            const data = ingredientList.find((v) => v.id == item.ingredient_id);
            console.log(item);
            // Pull stdQty (qty/100kg) and is_main from recipe_master by ingredient_id; positional fallback preserved.
            const recipeRow = RecipeData.data.data.find((r) => r.ingredient_id == item.ingredient_id);
            const stdQty = parseFloat(recipeRow?.qty ?? RecipeData.data?.data[index]?.qty ?? 0) || 0;
            const is_main = recipeRow?.is_main ? true : false;
            const dd = {ingredient_id : data.id, name : data.ingredient, required_qty: 0,  issued_qty: 0, excess_qty: 0, consume_qty: 0, return_qty : 0, store : data.store, stdQty, is_main}
            ddArray.push(dd);
          })
        }else if(RecipeData.data.data.length > 0){
          RecipeData.data.data.forEach((item) => {
            const data = ingredientList.find((v) => v.id == item.ingredient_id);
            const stdQty = parseFloat(item.qty) || 0;
            const is_main = item.is_main ? true : false;
            const dd = {ingredient_id : data.id, name : data.ingredient, required_qty: 0,  issued_qty: 0, excess_qty: 0, consume_qty: 0, return_qty : 0, store: data.store, stdQty, is_main}
            ddArray.push(dd);
          })
        }else{
          ddArray = [];
        }

        // Match Recipe Planning ordering: main items first, then Qty/100kg descending within each group.
        // Sort once here in state (not at render) because edit handlers identify rows by positional idx.
        ddArray.sort((a, b) => {
          if (!!a.is_main !== !!b.is_main) return a.is_main ? -1 : 1;
          return (parseFloat(b.stdQty) || 0) - (parseFloat(a.stdQty) || 0);
        });
        if( itemId && date && session){
          getDetailDispaly(plannedDetail, supportDetail, ddArray, itemId, date, session);
        }
        } catch (error) {
          console.error("Error fetching details:", error);
          toast.error("Failed to load item details");
        } finally {
          setLoading(false);
        }
      // setLoading(false)
      };
      fetchDetail();
      isEffectRan.current = true;
    }
  }, [mealList, activeIndex]);

  const getDetailDispaly = async (plannedDetail, supportDetail, ddArray,  itemId, date, session) => {
    try {
      if (plannedDetail && supportDetail) {
        const initialFormData = Array.from(
          { length: plannedDetail.length },
          (_, index) => ({
            batch: index + 1,
            batch_raw_material_qty: "",
            planned_batch_raw_qty: "",
            planned_vessel_id: "",
            vessel_id: "",
            planned_timeslot_start: "",
            planned_timeslot_end: "",
            timeslot_start: "",
            timeslot_end: "",
            requisition_no: "",
            remarks: "",
            ingredientDetail: ddArray
          })
        );
        const updatedFormData = await Promise.all(initialFormData.map(async(initialItem) => {
          const plannedObject = plannedDetail.find(
            (object) => object.batch === initialItem.batch
          );
          const supportObject = supportDetail.find(
            (object) => object.batch === initialItem.batch
          );
          if( itemId && date && session){
            const condition = `menu_item_id='${itemId}' AND date = '${date}' AND session='${session.value}' AND batch = '${initialItem.batch}'`;
            const RecipeData = await axios.get(`${baseUrl}/comman/list?table=production_receipe_planning&condition=${condition} `);

            // const SupportRecipeData = await axios.get(`${baseUrl}/comman/list?table=production_receipe_support&condition=${condition} `);

            let updatedIngredientDetail;
            if(RecipeData.data.data.length > 0){
              updatedIngredientDetail = initialItem.ingredientDetail.map((item, index) => {
                if (!item) {
                  console.warn("Found undefined item in ingredientDetail array");
                  return null; // Will be filtered out later
                }
                const receipeFind = RecipeData.data.data.find((val) => val.ingredient_id == item.ingredient_id);
                if(receipeFind){
                  // Water (ingredient_id 43): મળેલ (received) always mirrors મોકલેલ (issued = required_qty);
                  // for other ingredients, fall back to issued_qty only when no received value was saved.
                  const received = item.ingredient_id == 43
                    ? receipeFind.required_qty
                    : (receipeFind.received_qty ?? receipeFind.issued_qty);
                  return {ingredient_id : item.ingredient_id, name : item.name, required_qty: receipeFind.required_qty,  issued_qty: item.ingredient_id == 43 ? receipeFind.required_qty : receipeFind.issued_qty, received_qty: received, excess_qty: receipeFind.excess_qty, consume_qty: receipeFind.consume_qty, return_qty : receipeFind.return_qty, store: item.store , db_id : receipeFind.id};
                } else {
                  return { ...item };
                }
                
             })
           
           }else{
              updatedIngredientDetail = initialItem.ingredientDetail.map((item) => {
                if (!item) return null;
                return { ...item};
             })
           }
            initialItem.ingredientDetail = updatedIngredientDetail.filter(item => item !== null);
          }
          if (plannedObject && !supportObject) {
            const plannedVesselId = plannedObject.vessel_id;
            const plannedVesselItem = vesselList.find(
              (item) => item.id == plannedVesselId
            );
            const plannedVesselObject = plannedVesselItem
              ? { value: plannedVesselItem.id, label: plannedVesselItem.name }
              : { value: "", label: "" };

            const plannedTimeslot = plannedObject.start_time;
            const plannedTimeslotItem = timeList.find(
              (item) => item.value == plannedTimeslot
            );
            const plannedTimeslotObject = plannedTimeslotItem
              ? {
                  value: plannedTimeslotItem.value,
                  label: plannedTimeslotItem.label,
                }
              : { value: "", label: "" };
            
            const plannedEndTimeslot = plannedObject.end_time;
            const plannedEndTimeslotItem = timeList.find((item) => item.value == plannedEndTimeslot);
            const plannedEndTimeslotObject = plannedEndTimeslotItem
                ? {
                    value: plannedEndTimeslotItem.value,
                    label: plannedEndTimeslotItem.label,
                  }
                : { value: "", label: "" };

            plannedObject.planned_vessel_id = plannedVesselObject;
            plannedObject.planned_timeslot_start = plannedTimeslotObject;
            plannedObject.planned_timeslot_end = plannedEndTimeslotObject;
            plannedObject.planned_batch_raw_qty = plannedObject.planned_batch_raw_qty;
            plannedObject.requisition_no = plannedObject.requisition_no;
            console.log(plannedObject.requisition_no);
            plannedObject.remarks = "";
            
            return { ...initialItem, ...plannedObject };
          } else if (supportObject || plannedObject) {

            const supportVesselId = supportObject.vessel_id;
            const supportVesselItem = vesselList.find(
              (item) => item.id == supportVesselId
            );
            const supportVesselObject = supportVesselItem
              ? { value: supportVesselItem.id, label: supportVesselItem.name }
              : { value: "", label: "" };
            const timeslotStart = supportObject.timeslot_start;
            const timeslotStartItem = timeList.find(
              (item) => item.value == timeslotStart
            );
            const timeslotStartObject = timeslotStartItem
              ? {
                  value: timeslotStartItem.value,
                  label: timeslotStartItem.label,
                }
              : { value: "", label: "" };

            const timeslotEnd = supportObject.timeslot_end;
            const timeslotEndItem = timeList.find(
              (item) => item.value == timeslotEnd
            );
            const timeslotEndObject = timeslotEndItem
              ? { value: timeslotEndItem.value, label: timeslotEndItem.label }
              : { value: "", label: "" };
              
            const plannedVesselId = plannedObject?.vessel_id ?? 0;
            const plannedVesselItem = vesselList.find((item) => item.id == plannedVesselId);
            const plannedVesselObject = plannedVesselItem ? { value: plannedVesselItem.id, label: plannedVesselItem.name } : { value: "", label: "" };
  
            const plannedTimeslot = plannedObject?.start_time ?? 0;
            const plannedTimeslotItem = timeList.find((item) => item.value == plannedTimeslot);
            const plannedTimeslotObject = plannedTimeslotItem ? {value: plannedTimeslotItem.value, label: plannedTimeslotItem.label} : { value: "", label: "" };

            const plannedEndTimeslot = plannedObject?.end_time;
            const plannedEndTimeslotItem = timeList.find((item) => item.value == plannedEndTimeslot);
            const plannedEndTimeslotObject = plannedEndTimeslotItem
                ? {
                    value: plannedEndTimeslotItem.value,
                    label: plannedEndTimeslotItem.label,
                  }
                : { value: "", label: "" };
  
            initialItem.planned_vessel_id = plannedVesselObject;
            console.log(plannedObject);
            initialItem.planned_timeslot_start = plannedTimeslotObject;
            initialItem.planned_timeslot_end = plannedEndTimeslotObject;
            initialItem.batch_raw_material_qty = supportObject.batch_raw_material_qty ?? 0;
            initialItem.planned_batch_raw_qty = plannedObject?.planned_batch_raw_qty ?? 0;
            initialItem.vessel_id = supportVesselObject;
            initialItem.timeslot_start = timeslotStartObject;
            initialItem.timeslot_end = timeslotEndObject;
            initialItem.remarks = supportObject.remarks;
            initialItem.requisition_no = plannedObject?.requisition_no;
            // console.log(plannedObject.requisition_no);
            return { ...initialItem };
          } else {
            return initialItem;
          }
        }));
        // console.log(updatedFormData);
        setFormData(updatedFormData);
        setStoreRemarks(updatedFormData.find((row) => row.remarks)?.remarks ?? "");
      } else {
        const initialFormData = Array.from(
          { length: plannedDetail?.length ?? 0 },
          (_, index) => ({
            batch: index + 1,
            batch_raw_material_qty: "",
            planned_batch_raw_qty: "",
            planned_vessel_id: "",
            vessel_id: "",
            planned_timeslot: "",
            timeslot_start: "",
            timeslot_end: "",
            requisition_no: "",
            remarks: "",
            ingredientDetail: ddArray
          })
        );
        setFormData(initialFormData);
      }
    } catch (e) {
      console.error("Error in getDetailDispaly:", e);
      toast.error("Error loading details");
      console.log(e);
    }
  };

  const handleClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
    // A different item is a different set of batches, so the open one goes back to the first.
    setOpenBatch(0);
  };
  
  const getVesselList = async () => {
    const response = await axios.get(
      `${baseUrl}/comman/list?table=vessel_master&condition=status=1`
    );
    setVesselList(response.data.data);
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const list = response.data.data.filter((item) => item.status == 1);
    setIngredientList(list);
  };

  const getRMDetailForItem = async () => {
    setLoading(true)
    const item_id = mealList.find((item, index) => index == activeIndex);
    const condition = `date = '${date}' AND session = '${session.value}' AND menu_item_id = '${item_id.menu_item_id}'`;
    const response = await axios.get(
      `${baseUrl}/comman/list?table=raw_material&condition=${condition}`
    );
    setRMDetailForItem(response.data.data);
    setLoading(false)
  };

  const handelFilterChange = async (date, session) => {
    setDate(date);
    setSession(session);
    if (date && session) {
      const condition = ` m.session='${session.value}' AND m.date='${date}'`;
      const response = await axios.get(
        `${baseUrl}/meal_master/item_list?condition=${condition}`
      );
      setMealList(response.data.data);
    }
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;
    if(name == "batch_raw_material_qty"){
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index].ingredientDetail.map((item) => {
          const consume = updatedFormData[index].planned_batch_raw_qty > 0 ? ((item?.issued_qty ?? 0) * value / updatedFormData[index].planned_batch_raw_qty).toFixed(3) : 0;
          const excess = ((item?.issued_qty ?? 0) - consume).toFixed(3);
          item.consume_qty = consume;
          item.excess_qty = excess;
          item.return_qty = excess;
        })
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
      });
    }else{
      setFormData((prevFormData) => {
        const updatedFormData = [...prevFormData];
        updatedFormData[index] = { ...updatedFormData[index], [name]: value };
        return updatedFormData;
      });
    }
    
  };

  const handleSelectChange = async (index, data, option) => {
    setFormData((prevFormData) => {
      const updatedFormData = [...prevFormData];
      updatedFormData[index] = {
        ...updatedFormData[index],
        [option.name]: data,
      };
      return updatedFormData;
    });
  };

  const handleSave = async (e, index) => {
    console.log(formData[index])
    e.preventDefault();
    //setLoading(true)
    const menu_item_id =
      mealList.find((item, i) => i == activeIndex)?.menu_item_id ?? 0;
    const combineData = {
      // Remarks (stores) is the item's, asked once above the batches, so it rides along with
      // whichever batch is being saved rather than being typed again on each.
      formData: { ...formData[index], remarks: storeRemarks },
      date: date,
      session: session,
      menu_item_id: menu_item_id,
    };
    console.log(combineData);

    const { batch_raw_material_qty, vessel_id } = combineData.formData;

    if (!batch_raw_material_qty) {
      toast.error("Please enter Batch Raw Material qty.");
      return;
    }

    // The vessel is compulsory, and the red star beside it says so. The save went out without one
    // and came back a bare "Failed to submit the form", which names neither the field nor the
    // reason -- so it is turned away here, by name, the way the quantity above it is.
    if (!vessel_id?.value) {
      toast.error("Please select Vessel Name.");
      return;
    }
    try {
      setLoading(true);
      // setPopupOpen(true);

      await axios.post(`${baseUrl}/production_support/batch`, combineData);
      toast.success("Data successfully saved!");
      //window.location.reload();
    } catch (error) {
      toast.error("Failed to submit the form.");
      // setPopupOpen(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
    //setLoading(false)
  };

  const handlePlannedQtyChange = (e, formIndex, ingredientIndex, name) => {
    const { value } = e.target;
    
    setFormData((prevFormData) => {
      return prevFormData.map((batch, index) => {
          if (index + 1 === formIndex) {
              return {
                  ...batch,
                  ingredientDetail: batch.ingredientDetail.map((ingredient, idx) => {
                      if (idx === ingredientIndex) {
                        if(name == "issued_qty"){
                          const consume = batch.planned_batch_raw_qty > 0 ? (((batch?.batch_raw_material_qty ?? 0) * value) / batch.planned_batch_raw_qty).toFixed(3) : 0;
                          const excess = (value - consume).toFixed(3);
                          return {
                            ...ingredient,
                            [name]: value,
                            ["consume_qty"] : consume,
                            ["excess_qty"] : excess,
                            ["return_qty"] : excess,
                          };
                        }else if(name === "excess_qty"){ 
                          // User now inputs excess qty, and consume is calculated
                          const consume = (ingredient.received_qty - value).toFixed(3);
                          return { 
                            ...ingredient, 
                            [name]: value, 
                            ["consume_qty"]: consume, 
                            ["return_qty"]: value, 
                          }; 
                        }
                        // else if(name == "consume_qty"){
                        //   console.log(ingredient.issued_qty);
                        //   const excess = (ingredient.received_qty - value).toFixed(3);
                        //   return {
                        //     ...ingredient,
                        //     [name]: value,
                        //     ["excess_qty"] : excess,
                        //     ["return_qty"] : excess,
                        //   }
                        // }
                        else if(name == "received_qty"){
                          const consume = (value - ingredient.excess_qty).toFixed(3);
                          const excess = (value - ingredient.consume_qty).toFixed(3)
                          return {
                            ...ingredient,
                            [name]: value,
                            ["consume_qty"] : consume,
                            // ["return_qty"] : value,
                          }
                          }{
                          return {
                            ...ingredient,
                            [name]: value
                        };
                        }
                          
                      }
                      return ingredient;
                  })
              };
          }
          return batch;
      });
    });
  };

  const handleAddIngredient = async(ingredient) => {
    // console.log(formData[activeIndex].ingredientDetail)
    console.log(batchIndex,ingredient)
    // Neither branch below said anything. The row went onto the list in silence, and when the
    // guard turned it away -- no batch to add to -- it was turned away in silence too, so the
    // modal shut on a press that had done nothing and there was no way to tell which.
    if(!(batchIndex >= 0 && formData[batchIndex])){
      toast.error("Could not add the ingredient -- open a batch and try again.");
      return;
    }

    const ob = {
      consume_qty: null,
      excess_qty: null,
      ingredient_id:ingredient.value,
      issued_qty:null,
      name: ingredient.name,
      unit:ingredient.data.unit,
      received_qty: null,
      required_qty: null, 
      return_qty:null,
      store: ingredient.data.store
    };

    console.log(ingredient)

    // Onto every batch, not just the one that asked. An ingredient that went into the pot is an
    // ingredient of the dish, and the screen only offers the button on batch 1 for that reason:
    // adding it per batch would leave the batches with different ingredient lists and no way to
    // tell which was the true one. Each batch gets its own copy of the row, so the quantities
    // typed into one do not turn up in the others.
    const updatedFormData = formData.map((row) => ({
      ...row,
      ingredientDetail: [...row.ingredientDetail, { ...ob }],
    }));

    // Update the state with the new form data
    setFormData(updatedFormData);
    setBatchIndex(null)
    // On the list, not yet in the database: SAVE on the batch is what writes it, and this screen
    // adds without reloading, so nothing else would tell the user that.
    toast.success(`${ingredient.name} added -- press SAVE on the batch to store it.`);
} 

const handleExport = async (e, index) => {
  e.preventDefault();

  const menu_item = mealList.find((item, i) => i === activeIndex);
  const batchRow = formData[index];
  if (!batchRow) {
    toast.error("Nothing to export for this batch.");
    return;
  }

  // Excel opened this file on "We found a problem with some content" and offered to recover it.
  // The sheet was built by writing cell objects straight onto the worksheet after aoa_to_sheet
  // had made it, and two of the things that produced are ones Excel treats as damage:
  //
  //   - a merge over row 7, which has no cells in it at all. A merged range has to have its
  //     anchor cell present in the sheet; that row was a blank spacer, so the range pointed at
  //     nothing. It bought nothing either -- merging an empty row changes nothing on the page.
  //   - merges laid over cells that still held their own values. "Item :" was merged across E:F
  //     while F carried the item name, which was then written a SECOND time into G. Only the
  //     top-left of a merge is ever shown, so the value in F was invisible and contradicted the
  //     range covering it.
  //
  // So the whole sheet is one array now, and the merges only ever cover the label or value cell
  // they belong to. Cells built by aoa_to_sheet also carry their own type; the hand-written ones
  // did not, and left the writer to guess at what a number or a blank was meant to be.
  const rows = [
    ["Production Support Slip( Store / Support )"],
    [],
    ["Requisition No.", batchRow.requisition_no ?? ""],
    // null leaves no cell behind, which is what the cell under a merge should be.
    ["Date :", formatDate(date), "Session :", session?.label ?? "", "Item :", null, menu_item?.item_name ?? "", null],
    ["Batch :", batchRow.batch ?? "", "Vessel :", batchRow.vessel_id?.label ?? "", "Plan Batch Qty :", null, batchRow.planned_batch_raw_qty ?? "", null],
    [],
    [],
    ["Sr. No.", "નામ", "Unit", "મોકલેલ", "મળેલ", "વપરાયેલ", "બચેલું", "રીટર્ન"],
  ];

  (batchRow.ingredientDetail ?? []).forEach((item, idx) => {
    rows.push([
      idx + 1,
      item.name,
      item.unit?.name,
      item.issued_qty,
      item.received_qty,
      item.consume_qty,
      item.excess_qty,
      item.return_qty,
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(rows);

  // Every anchor below is a cell the array above actually writes.
  ws["!merges"] = [
    { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } }, // the title, across the sheet
    { s: { r: 2, c: 1 }, e: { r: 2, c: 7 } }, // Requisition No.'s value
    { s: { r: 3, c: 4 }, e: { r: 3, c: 5 } }, // "Item :"
    { s: { r: 3, c: 6 }, e: { r: 3, c: 7 } }, // the item name
    { s: { r: 4, c: 4 }, e: { r: 4, c: 5 } }, // "Plan Batch Qty :"
    { s: { r: 4, c: 6 }, e: { r: 4, c: 7 } }, // the planned quantity
  ];

  // Eight columns, because the sheet has eight. It carried thirteen widths, five of them for
  // columns that do not exist.
  ws["!cols"] = [
    { wch: 8 },  // Sr. No.
    { wch: 26 }, // નામ
    { wch: 8 },  // Unit
    { wch: 10 }, // મોકલેલ
    { wch: 10 }, // મળેલ
    { wch: 10 }, // વપરાયેલ
    { wch: 10 }, // બચેલું
    { wch: 10 }, // રીટર્ન
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "All_Ingredients");

  // formatDate is en-GB -- 29/07/2026 -- and a slash cannot appear in a filename, so the browser
  // rewrites the name while saving and the file that lands is not the one the code asked for.
  // formatDateForFile spells the same date with underscores; the item name is cleaned the same
  // way, since a dish name is free text and Windows refuses a fair few characters in a filename.
  const safe = (text) => String(text ?? "").replace(/[\\/:*?"<>|]/g, "_").trim();
  XLSX.writeFile(wb, `Production_Support_${formatDateForFile(date)}_${safe(session?.label)}_${safe(menu_item?.item_name)}.xlsx`);
};

  useEffect(() => {
      console.log(formData);
  }, [formData]);
  return (
    // The page's left edge, owned in one place. The heading used to carry it (px-2 sm:px-6)
    // while everything under it carried none, so on a desk the title sat 24px in and the filter
    // and the item bars started hard against the window -- three different left edges down one
    // screen. The padding moves here and the heading gives up its own, so there is one.
    <div className="px-2 sm:px-6">
      {loading && <Loader/>}
      <div className="flex justify-between items-center py-3">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Production Support
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        {/* Date, session and Submit on one line -- this screen is worked on a phone.
            -mx-2 cancels the compact filter's own px-2 so its date box starts on the same edge
            as the heading above and the item bars below, rather than 8px inside them. The filter
            is shared with Rotli Production, so the padding is taken off here, not in it. */}
        <div className="-mx-2">
          <DateSessionFilter handleFilterChange={handelFilterChange} compact />
        </div>
        <div>
          {mealList.map((item, index) => (
            <div key={index} className="border-b mt-3">
              {/* A thinner bar than it was: on a phone the item name is one line and the p-4 band
                  around it was costing a fifth of the screen before any work started. */}
              {/* The name takes the row and wraps inside it; the chevron keeps its size.
                  Without min-w-0 a flex item will not shrink below its longest word, so a name
                  like "Salad Tukdi (Kobi Tameta)" pushed this bar wider than a phone screen. That
                  scrolls the whole PAGE sideways, and every bar then loses its first characters
                  off the left edge -- short names as well, which is what made it look like the
                  padding was wrong rather than one long name. */}
              <div
                className="flex justify-between items-center gap-2 px-3 py-1.5 cursor-pointer accordion-title bg-orange-400 border rounded"
                onClick={() => handleClick(index)}
              >
                <span className="text-sm font-medium min-w-0 flex-1 break-words"><ItemNameStacked item={item} /></span>
                {index === activeIndex ? (
                  <ChevronUpIcon className="w-5 h-5 shrink-0" />
                ) : (
                  <ChevronDownIcon className="w-5 h-5 shrink-0" />
                )}
              </div>
              {index === activeIndex && (
                <div className="space-y-3 p-2 sm:p-4 bg-white">
                  {/* The item's own two facts, above the batches. Total Actual and Pending are
                      gone from here: they were two more lines of arithmetic on a screen whose
                      whole problem is height, and the actual quantity is read per batch below. */}
                  <div className="space-y-2 max-w-xl">
                    <div className="flex flex-wrap items-center gap-2">
                      <div className="text-sm font-bold">Planned Raw Material Qty (Kgs.) :</div>
                      <div className="text-sm">{rmDetailForItem?.[0]?.planned_rm_qty ?? 0}</div>
                    </div>
                    <div className="flex flex-wrap items-center gap-2">
                      <div className="text-sm font-bold whitespace-nowrap">Remarks (stores) :</div>
                      <input
                        type="text"
                        id="store_remarks"
                        name="store_remarks"
                        placeholder="Remarks"
                        value={storeRemarks}
                        onChange={(e) => setStoreRemarks(e.target.value)}
                        className="flex-1 min-w-0 border p-1 rounded-md text-sm bg-orange-50"
                      />
                    </div>
                  </div>

                  {batchIndex >= 0 && formData[batchIndex] && <ModalContent showModal={showModal} setShowModal={setShowModal} ingredientList={ingredientList} handleAddIngredient={handleAddIngredient} ingredientDetail={formData[batchIndex].ingredientDetail} />}

                  {formData.length === 0 && (
                    <div className="text-sm text-gray-500">
                      No batches planned for this item yet -- they come from Kit Requisition.
                    </div>
                  )}

                  {formData.map((batchRow, batchIdx) => (
                    <div key={batchIdx} className="border rounded">
                      {/* A batch is a screenful of its own, so each one opens and closes. */}
                      <div
                        className="flex flex-wrap items-center gap-x-4 gap-y-1 px-3 py-1.5 bg-rose-100 cursor-pointer"
                        onClick={() => setOpenBatch(openBatch === batchIdx ? null : batchIdx)}
                      >
                        <span className="text-sm font-bold">Batch</span>
                        <span className="text-sm">{batchRow.batch}</span>
                        <span className="text-sm font-bold">Kit No.</span>
                        <span className="text-sm flex-1 min-w-0 truncate">{batchRow.requisition_no ?? "-"}</span>
                        {openBatch === batchIdx ? (
                          <ChevronUpIcon className="w-5 h-5" />
                        ) : (
                          <ChevronDownIcon className="w-5 h-5" />
                        )}
                      </div>

                      {openBatch === batchIdx && (
                        <div className="p-2 space-y-3">
                          {/* Planned beside Actual, one row per thing, so the two are read against
                              each other. Time slot is deliberately not here -- see below. */}
                          <div className="overflow-x-auto">
                            <table className="text-xs sm:text-sm border-collapse w-full">
                              <thead>
                                {/* The label column is what the two value columns are short of on a
                                    phone: at w-40 it took 160 of about 340 usable pixels and left a
                                    vessel name or a time slot with a sliver to appear in. w-24 there,
                                    and the labels wrap onto a second line instead -- a wrapped label
                                    is still readable, a clipped value is not. Unchanged from sm up,
                                    where there was never a shortage. */}
                                <tr className="bg-gray-100">
                                  <th className="border border-gray-300 p-1 text-left w-24 sm:w-40"></th>
                                  <th className="border border-gray-300 p-1 font-bold">Planned</th>
                                  <th className="border border-gray-300 p-1 font-bold">Actual</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="border border-gray-300 p-1 font-bold">
                                    Batch RM Qty.<span className="text-red-500">*</span>
                                  </td>
                                  <td className="border border-gray-300 p-1">
                                    <input
                                      type="number"
                                      step="0.01"
                                      id={`planned_batch_raw_qty_${batchIdx}`}
                                      placeholder="Planned"
                                      disabled
                                      name="planned_batch_raw_qty"
                                      value={batchRow.planned_batch_raw_qty}
                                      onChange={handleInputChange(batchIdx)}
                                      onWheel={(e) => e.target.blur()}
                                      className="w-full border p-1 rounded-md text-xs"
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-1">
                                    <input
                                      type="number"
                                      step="0.01"
                                      id={`batch_raw_material_qty_${batchIdx}`}
                                      placeholder="Actual"
                                      name="batch_raw_material_qty"
                                      value={batchRow.batch_raw_material_qty}
                                      onChange={handleInputChange(batchIdx)}
                                      onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                      onWheel={(e) => e.target.blur()}
                                      className="w-full border p-1 rounded-md text-xs bg-orange-50"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <td className="border border-gray-300 p-1 font-bold">
                                    Vessel Name<span className="text-red-500">*</span>
                                  </td>
                                  <td className="border border-gray-300 p-1">
                                    <Select
                                      classNamePrefix="select"
                                      menuPortalTarget={document.body}
                                      styles={selectStyles(false)}
                                      name="planned_vessel_id"
                                      placeholder="Planned"
                                      value={batchRow.planned_vessel_id}
                                      onChange={(selectedOption, name) => {
                                        handleSelectChange(batchIdx, selectedOption, name);
                                      }}
                                      options={vesselList.map((v) => ({ value: v.id, label: v.name }))}
                                      isDisabled={true}
                                      filterOption={(option, inputValue) =>
                                        option.data.label.toLowerCase().includes(inputValue.toLowerCase())
                                      }
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-1">
                                    <Select
                                      classNamePrefix="select"
                                      menuPortalTarget={document.body}
                                      styles={selectStyles(true)}
                                      name="vessel_id"
                                      placeholder="Actual"
                                      value={batchRow.vessel_id}
                                      onChange={(selectedOption, name) => {
                                        handleSelectChange(batchIdx, selectedOption, name);
                                      }}
                                      options={vesselList.map((v) => ({ value: v.id, label: v.name }))}
                                      filterOption={(option, inputValue) =>
                                        option.data.label.toLowerCase().includes(inputValue.toLowerCase())
                                      }
                                    />
                                  </td>
                                </tr>
                                {/* "Time slot (Hide it)". The planned start and end slots are still
                                    loaded and still saved -- they are just not shown, because the
                                    row below is the one anybody on this screen fills in. */}
                                <tr>
                                  <td className="border border-gray-300 p-1 font-bold">Actual start / end time</td>
                                  <td className="border border-gray-300 p-1">
                                    <Select
                                      classNamePrefix="select"
                                      menuPortalTarget={document.body}
                                      styles={selectStyles(true)}
                                      name="timeslot_start"
                                      value={batchRow.timeslot_start}
                                      onChange={(selectedOption, name) => {
                                        handleSelectChange(batchIdx, selectedOption, name);
                                      }}
                                      placeholder="Start time"
                                      options={timeList.map((t) => ({ value: t.value, label: t.label }))}
                                      filterOption={(option, inputValue) =>
                                        option.data.label.toLowerCase().includes(inputValue.toLowerCase())
                                      }
                                    />
                                  </td>
                                  <td className="border border-gray-300 p-1">
                                    <Select
                                      classNamePrefix="select"
                                      menuPortalTarget={document.body}
                                      styles={selectStyles(true)}
                                      name="timeslot_end"
                                      value={batchRow.timeslot_end}
                                      placeholder="End time"
                                      onChange={(selectedOption, name) => {
                                        handleSelectChange(batchIdx, selectedOption, name);
                                      }}
                                      options={timeList.map((t) => ({ value: t.value, label: t.label }))}
                                      filterOption={(option, inputValue) =>
                                        option.data.label.toLowerCase().includes(inputValue.toLowerCase())
                                      }
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          {batchRow.ingredientDetail.length > 0 && (
                            <div className="overflow-x-auto">
                              {/* w-full, like the Planned/Actual table above it: the two sit in the
                                  same card and read as one block, and a table sized to its own
                                  content stopped a third of the way across while that one ran the
                                  full width. Below `sm` the seven columns are wider than the card
                                  either way, and the scroll box around them still takes over. */}
                              <table className="text-xs border-collapse w-full">
                                <thead>
                                  <tr className="bg-gray-100">
                                    <th className={`${stickyCol} bg-gray-100 text-left`}>નામ</th>
                                    <th className={qtyHead}>માંગેલ</th>
                                    <th className={qtyHead}>મોકલેલ</th>
                                    <th className={qtyHead}>મળેલ</th>
                                    <th className={qtyHead}>બચેલું</th>
                                    <th className={qtyHead}>વપરાયેલ</th>
                                    <th className={qtyHead}>રીટર્ન</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {batchRow.ingredientDetail.map((ing, idx) => (
                                    <tr key={idx} className="bg-white">
                                      <th scope="row" className={`${stickyCol} bg-white text-left font-normal`}>{ing.name}</th>
                                      <td className={qtyCell}><input type="number" value={ing.required_qty} className="w-16 p-1 border rounded-md text-center text-xs" disabled /></td>
                                      <td className={qtyCell}><input type="number" onWheel={(e) => e.target.blur()} disabled step="0.01" id={`issued_qty_${batchIdx}_${idx}`} placeholder="મોકલેલ" onChange={(e) => handlePlannedQtyChange(e, batchIdx+1, idx, "issued_qty")} name={`issued_qty_${batchIdx}_${idx}`} value={ing.issued_qty} className="w-16 p-1 border rounded-md text-xs bg-orange-50"/></td>
                                      <td className={qtyCell}><input type="number" onWheel={(e) => e.target.blur()} onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}} step="0.01" id={`received_qty_${batchIdx}_${idx}`} placeholder="મળેલ" onChange={(e) => handlePlannedQtyChange(e, batchIdx+1, idx, "received_qty")} name={`received_qty_${batchIdx}_${idx}`} value={ing.received_qty} className={`w-16 p-1 border rounded-md text-xs ${ing.received_qty != ing.issued_qty ? 'bg-gray-300' : 'bg-orange-50'}`}/></td>
                                      <td className={qtyCell}><input type="number" onWheel={(e) => e.target.blur()} onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}} step="0.01" id={`excess_qty_${batchIdx}_${idx}`} placeholder="બચેલું" onChange={(e) => handlePlannedQtyChange(e, batchIdx+1, idx, "excess_qty")} name={`excess_qty_${batchIdx}_${idx}`} value={ing.excess_qty} className="w-16 p-1 border rounded-md text-xs bg-orange-50"/></td>
                                      <td className={qtyCell}><input type="number" onWheel={(e) => e.target.blur()} onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}} step="0.01" id={`consume_qty_${batchIdx}_${idx}`} placeholder="વપરાયેલ" onChange={(e) => handlePlannedQtyChange(e, batchIdx+1, idx, "consume_qty")} name={`consume_qty_${batchIdx}_${idx}`} value={ing.consume_qty} className="w-16 p-1 border rounded-md text-xs" disabled/></td>
                                      <td className={qtyCell}><input type="number" onWheel={(e) => e.target.blur()} onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}} step="0.01" id={`return_qty_${batchIdx}_${idx}`} placeholder="રીટર્ન" onChange={(e) => handlePlannedQtyChange(e, batchIdx+1, idx, "return_qty")} name={`return_qty_${batchIdx}_${idx}`} value={ing.return_qty} className="w-16 p-1 border rounded-md text-xs bg-orange-50"/></td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          )}

                          <div className="flex flex-wrap items-center gap-2">
                            {/* Asked on the first batch only, and answered for all of them. */}
                            {batchIdx === 0 && (
                              <button
                                onClick={() => setBatchIndex(batchIdx)}
                                className="px-3 py-1.5 bg-blue-500 text-white rounded-md text-sm"
                              >
                                Add Ingredient
                              </button>
                            )}
                            <button
                              onClick={(e) => { handleExport(e, batchIdx); }}
                              className="px-3 py-1.5 bg-blue-500 text-white rounded-md text-sm"
                            >
                              EXPORT
                            </button>
                            <button
                              onClick={(e) => { handleSave(e, batchIdx); }}
                              className="px-3 py-1.5 bg-green-500 text-white rounded-md text-sm"
                            >
                              SAVE
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ProductionSupport;
